module.exports = __webpack_public_path__ + "img/ford-multislider-bg-2025.78175bb2.jpg";